<template>
  <div class="city-tags">
    <span
      class="tag-item no-select-text"
      v-for="item in cities"
      :key="item[fields.id]"
      @click="changeCity(item)"
      :class="getTagClass(item[fields.id])"
    >{{item[fields.name]}}</span>
  </div>
</template>

<script>
export default {
  props: {
    cities: {
      type: Array,
      required: true
    },

    fields: {
      type: Object,
      default: _ => ({
        id: "id",
        name: "name"
      })
    }
  },

  data() {
    return {
      currentCity: {}
    };
  },

  computed: {
    currentCityId() {
      return this.currentCity[this.fields.id] || "";
    }
  },

  watch: {
    currentCityId(newValue) {
      this.$emit("getCurrentTag", this.currentCity);
    }
  },

  methods: {
    changeCity(item) {
      this.currentCity = this.$js.deepClone(item);
    },

    getTagClass(id) {
      if (this.currentCityId === id) return "active";
      return "";
    },

    resetCurrentCity() {
      if (!this.currentCityId) return;
      this.currentCity = {};
    }
  }
};
</script>

<style scoped lang="scss">
.city-tags {
  .tag-item {
    display: inline-block;
    padding: 5px 10px;
    margin: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .active {
    background: #2b85e4;
    color: #fff;
  }
}
</style>